// One-shot supplier-name handoff between the two payment views (/suppliers and
// /suppliers/paid). When an empty state on one tab says "this supplier's money is
// on the other tab", the jump link stashes the searched name here; the target
// page reads it ONCE on mount and clears it, so the same supplier is pre-searched
// there. The date range already carries via sharedDateRange.js, so together the
// user lands on exactly this supplier, same period, on the other tab.
//
// Per-user sessionStorage, same as sharedDateRange. One-shot (deleted on read) so
// a stale name never re-applies on a later normal visit to the tab.
const key = (uid) => `peak.supplierJump.${uid ?? 'anon'}`;

// Read and consume the pending jump name (returns '' when none). Deleting on
// read is what makes it one-shot — call it once, in the page's state initializer.
export function takeSupplierJump(uid) {
  try {
    const v = sessionStorage.getItem(key(uid));
    if (v != null) sessionStorage.removeItem(key(uid));
    return v || '';
  } catch {
    return '';
  }
}

export function setSupplierJump(uid, name) {
  try {
    sessionStorage.setItem(key(uid), name || '');
  } catch {
    /* storage disabled / full — non-fatal, the target just won't pre-search */
  }
}
